import {
  type AddressI18nFormScheme,
  type GeoCodeResponse,
} from '@Src/types/deliveryLocationFormTypes';
import Cookies from 'js-cookie';

interface ApiResponse<T> {
  Data: T;
  Code: number;
  DeveloperMessage: string | null;
  Success: boolean;
  UserMessage: string | null;
}

const baseUrl = 'https://api.flipdish.co';

const formatGoogleAddress = async ({
  appId,
  geoCodeResponse,
  language,
  version,
}: {
  appId: string;
  geoCodeResponse: GeoCodeResponse;
  language: string;
  version?: string;
}): Promise<ApiResponse<AddressI18nFormScheme>> => {
  const headers = {
    'Content-Type': 'application/json',
    'Flipdish-App-Type': 'Web',
    'Flipdish-App-Version': version || '',
    'Flipdish-White-Label-Id': appId,
    'X-Flipdish-Token': Cookies?.get('flipdish-token') || '',
  };

  const data = await fetch(
    `${baseUrl}/address/formatGoogleAddress?language=${language}`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(geoCodeResponse),
    },
  );
  const response = await data.json();
  return response;
};

export default formatGoogleAddress;
